"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Text = _interopRequireDefault(require("../Text"));
var _Image = _interopRequireDefault(require("../Image"));
var _Truncate = _interopRequireDefault(require("../Truncate"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      fontSize: theme.typography.pxToRem(16)
    },
    h2: {
      marginBottom: '5px',
      marginTop: '0 !important'
    },
    h3: {
      textAlign: 'center',
      margin: '0 !important'
    },
    stageTitleLink: {
      color: theme.palette.common.black
    },
    stageLink: {
      display: 'inline-block'
    },
    indicator: {
      position: 'relative',
      height: '13px',
      margin: '8px 0'
    },
    indicatorDot: {
      position: 'absolute',
      width: '13px',
      height: '13px',
      border: "solid 1px ".concat(theme.palette.grey[600]),
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '13px',
      zIndex: 1,
      left: '50%',
      transform: 'translateX(-50%)'
    },
    indicatorLineLeft: {
      position: 'absolute',
      height: '7px',
      width: 'calc(50% + ' + theme.spacing(3) + 'px)',
      left: -theme.spacing(3),
      borderBottom: "solid 1px ".concat(theme.palette.grey[600])
    },
    indicatorLineRight: {
      position: 'absolute',
      height: '7px',
      width: 'calc(50% + ' + theme.spacing(3) + 'px)',
      right: -theme.spacing(3),
      borderBottom: "solid 1px ".concat(theme.palette.grey[600])
    },
    linkList: {
      margin: '6px 0',
      padding: '0',
      listStyleType: 'none',
      '& > li': {
        margin: '0',
        padding: '0'
      }
    }
  };
});
var imageStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      marginBottom: '10px',
      textAlign: 'center',
      '& img': {
        marginBottom: 0,
        maxWidth: '100%'
      }
    }
  };
});
var HorizontalWFEditConfig = {
  emptyLabel: 'Workflow Horizontal',
  isEmpty: function isEmpty(props) {
    if (props.stages && props.stages.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var HorizontalWorkflow = function HorizontalWorkflow(_ref) {
  var _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? 'Workflow Horizontal' : _ref$heading,
    itemText = _ref.itemText,
    stages = _ref.stages,
    ariaLabel = _ref.ariaLabel,
    anchorId = _ref.anchorId;
  var classes = useStyles();
  var imageClasses = imageStyles();
  return __jsx("div", {
    id: anchorId,
    className: classes.wrapper,
    "aria-label": ariaLabel
  }, heading && __jsx("h2", {
    className: classes.h2,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), itemText && itemText.text && __jsx(_Text.default, itemText), stages && stages.length > 0 && __jsx(_core.Grid, {
    container: true,
    spacing: 6
  }, stages.map(function (stage, index1) {
    var titleLinkProps = stage.external && {
      target: '_blank',
      rel: 'noopener'
    };
    return __jsx(_core.Grid, {
      key: index1,
      item: true,
      xs: 12,
      md: stages.length === 3 ? 4 : 3
    }, stage.title && __jsx("h3", {
      className: classes.h3
    }, stage.url ? __jsx(_core.Link, (0, _extends2.default)({
      href: stage.url
    }, titleLinkProps, {
      className: classes.stageTitleLink
    }), __jsx(_Truncate.default, {
      lineHeight: 1.2
    }, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: stage.title
      }
    }))) : __jsx(_Truncate.default, {
      lineHeight: 1.2
    }, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: stage.title
      }
    }))), __jsx("div", {
      className: classes.indicator
    }, index1 !== 0 && __jsx("div", {
      className: classes.indicatorLineLeft
    }), __jsx("div", {
      className: classes.indicatorDot
    }), index1 !== stages.length - 1 && __jsx("div", {
      className: classes.indicatorLineRight
    })), stage.image && stage.image.src && __jsx(_Image.default, (0, _extends2.default)({}, stage.image, {
      link: stage.url,
      classesInjected: imageClasses
    })), stage.itemText && stage.itemText.text && __jsx(_Text.default, stage.itemText), stage.text && __jsx(_Text.default, {
      text: stage.text
    }), stage.links && __jsx("ul", {
      className: classes.linkList
    }, stage.links.map(function (link, index2) {
      var linkProps = link.external && {
        target: '_blank',
        rel: 'noopener'
      };
      return __jsx("li", {
        key: index2
      }, __jsx(_core.Link, (0, _extends2.default)({
        href: link.linkUrl
      }, linkProps, {
        className: classes.stageLink
      }), __jsx(_Truncate.default, {
        lines: 2
      }, __jsx("span", {
        dangerouslySetInnerHTML: {
          __html: link.linkText
        }
      }))));
    })));
  })));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/workflows/horizontal')(HorizontalWorkflow, HorizontalWFEditConfig);
exports.default = _default;